import React from 'react';
import Button from './Button';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import makeStyles from '@mui/styles/makeStyles';
import { AppRoutes } from '@monorepo/shared/src/types';

const t = (key: string) => translate('a11y', key);

const ForFamiliesButton: React.FC = () => {
  const classes = useStyles();
  return (
    <Button
      className={classes.button}
      color="secondary"
      redirectRoute={{ path: `/${AppRoutes.REPORTS}`, title: AppRoutes.REPORTS }}
      aria-label={t('buttons.forFamiliesButton')}
    >
      {t('buttons.forFamilies')}
    </Button>
  );
};

const useStyles = makeStyles((theme) => ({
  button: {
    width: theme.typography.pxToRem(260),
    maxHeight: theme.typography.pxToRem(72),
  },
}));

export default ForFamiliesButton;
